import { extractGradientColors } from '../../../../utils/extractGradientColors';
import { isGradientColor } from '../../../../utils/isGradientColor';

export function getDisplayColor(color: string) {
  const isGradient = isGradientColor(color);

  if (!isGradient) {
    return color;
  }

  const colors = extractGradientColors(color);

  if (!colors) {
    return color;
  }

  return `${colors?.color1}, ${colors?.color2}`;
}
